import { PublicButton } from '@yes.technology/react-toolkit'
import React from 'react'

export type PublicButtonPropsWithType = React.ComponentProps<
  typeof PublicButton
> & {
  type: 'public'
  link?: { url: string; target?: string }
  label?: string
}

export function isPublicButton(
  button: unknown
): button is PublicButtonPropsWithType {
  return (button as PublicButtonPropsWithType)?.type === 'public'
}

export function getPublicButtonRest<
  T extends { type?: unknown; link?: unknown; label?: unknown }
>(props: T): Omit<T, 'type' | 'link' | 'label'> {
  const { type: _t, link: _l, label: _lb, ...rest } = props
  return rest as Omit<T, 'type' | 'link' | 'label'>
}
